<template>
  <v-container class="pa-0 partner">
    <v-layout wrap>
      <v-row>
        <div class="page__title">
          <h1>{{ partner.name }}</h1>
        </div>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <div class="partner-images">
            <img
              class="partner-background"
              alt="Zdjęcie w tle partnera"
              :src="partner.backgroundImage ? mediaUrl + partner.backgroundImage : '/img/no-image.png'"
            />

            <img
              class="partner-avatar"
              alt="Zdjęcie profilowe partnera"
              :src="partner.mainImage ? mediaUrl + partner.mainImage : '/img/no-image.png'"
            />
          </div>

          <div class="partner-description" v-html="partner.description" />
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="v-card--no-style separate--after separate--before--md">
            <div role="group" aria-label="Kontakt" class="v-card-h1">Kontakt</div>

            <ul class="tags-container mb-8 px-0" role="region" aria-label="Numer telefonu">
              <li v-if="partner.phoneNumber" class="tag">
                <v-icon mr-4>mdi-phone</v-icon>

                <p class="sr-only">Numer telefonu:</p>

                <p>{{ partner.phoneNumber }}</p>
              </li>

              <li v-if="partner.email" class="tag" role="region" aria-label="Email">
                <v-icon class="mr-4">mdi-email</v-icon>

                <p class="sr-only">Adres e-mail:</p>

                <a :href="'mailto:' + partner.email">{{ partner.email }}</a>
              </li>

              <li v-if="address(partner)" class="tag" role="region" aria-label="Adres">
                <v-icon class="mr-4">mdi-map-marker</v-icon>

                <p class="sr-only">Lokalizacja:</p>

                <p>{{ address(partner) }}</p>
              </li>

              <li v-if="partner.open" class="tag" role="region" aria-label="Czas otwarcia">
                <v-icon class="mr-4">mdi-timer</v-icon>

                <p class="sr-only">Godziny otwarcia:</p>

                <p>{{ partner.open }}</p>
              </li>

              <li v-if="partner.website" class="tag" role="region" aria-label="Strona partnera">
                <v-icon class="mr-4">mdi-link-variant</v-icon>

                <p class="sr-only">Strona wwww:</p>

                <a :href="websiteUrl">{{ partner.website }}</a>
              </li>
            </ul>
          </v-card>

          <places v-if="places.length" :places="places" />
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col>
          <v-card class="v-card--no-style mt-3">
            <div class="v-card-h1">Usługi</div>
          </v-card>

          <v-row>
            <v-col v-for="(benefit, index) in benefits" :key="index" cols="12" lg="6">
              <event :event="benefit" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <gallery v-if="imageArray.length" :images="imageArray" />
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { address } from '@witkac/kartamiejska-shared';

import Event from '@/components/cards/Event';
import Gallery from '@/components/gallery/Gallery';
import Places from '@/components/partner/Places';
import { mediaMixin } from '@/mixins/media';
import { imagesMixin } from '@/mixins/images';
// @vuese
// Szczegóły partnera
// @group partner
export default {
  components: { Gallery, Places, Event },
  mixins: [mediaMixin, imagesMixin],
  computed: {
    ...mapState({
      benefits: state => state.benefit.list,
      partner: state => state.partner.data,
      places: state => state.place.list
    }),
    geo() {
      return {
        lat: this.partner.lat,
        lng: this.partner.lng
      };
    },
    websiteUrl() {
      if (this.partner.website.match(/^https?:\/\//gi)) {
        return this.partner.website;
      }
      return 'http://' + this.partner.website;
    },
    imageArray() {
      return this.images(this.partner.images);
    }
  },
  methods: {
    // @vuese
    // Filtr adresu
    address
  }
};
</script>

<style>
.partner .v-card__title h3 {
  display: none;
}
h3.object b {
  font-size: 1.25rem;
  color: teal;
  font-weight: normal;
}
h2 {
  margin-top: 1rem;
  color: #008080 !important;
  font-size: 1.35rem;
  text-transform: uppercase;
  padding-left: 0 !important;
}
</style>
